import { cn } from "@/utils/cn";
import React, { useState } from "react";
import RenderToast from "@/components/RenderToast";
import { usePost } from "@/apiHooks/commonMethods";
import BannerEditorModal from ".";

export const BannerPreviewModal = ({ data, image_url, className, api }) => {
  const [modalImageUrl, setModalImageUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSuccess = (action) => (data) => {
    handleCloseModal();
    RenderToast({
      type: "success",
      message: `Banner ${action} successfully.`,
    });
  };

  const { mutate: saveEdit } = usePost({
    apiURL: `${api}/${data.id}/banner`,
    isFormData: true,
    onSuccess: handleSuccess("edited"),
  });

  const handleSubmit = (data) => {
    const formData = new FormData();
    if (data.id) {
      formData.append("_method", "PUT");
    }
    formData.append("image_config[x]", data.image_config?.x);
    formData.append("image_config[y]", data.image_config?.y);
    formData.append("image_config[zoom_scale]", data.image_config?.zoom_scale);
    saveEdit(formData);
  };

  const handleOpenModal = (imageUrl) => {
    setModalImageUrl(imageUrl);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setModalImageUrl(null), 100);
  };

  return (
    <div
      className="relative cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        if (!isModalOpen) {
          handleOpenModal(image_url);
        }
      }}
    >
      <img
        src={image_url}
        alt="preview"
        className={cn("w-16 object-cover duration-300", className)}
      />
      {isModalOpen && modalImageUrl && (
        <BannerEditorModal
          onSubmit={handleSubmit}
          onClose={handleCloseModal}
          imageUrl={modalImageUrl}
          data={data}
        />
      )}
    </div>
  );
};
